// /v3/stations/{stationId}/metadata

import { Metadata } from '../../types/Metadata';

function getEndpointUrl(webStationId: string) {
  return `/api/proxy/v3/stations/webStationId:${webStationId}/metadata`;
}

type Params = {
  webStationId: string;
  userId: string;
  metadata: Metadata;
};

const updatePodcastMetadata = async (params: Params) => {
  const { webStationId, userId, metadata } = params;
  const url = getEndpointUrl(webStationId);
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      userId,
      ...metadata,
    }),
  });
  if (response.ok) {
    return response.status;
  }
  throw new Error(`${response.status} - ${response.statusText}`);
};

export { updatePodcastMetadata };
